import React from 'react';
import {
    ColorfulPdfImageIcon,
    ColorfulImageEditorIcon,
    ColorfulCurrencyIcon,
    ColorfulJsonIcon,
    ColorfulOcrIcon,
    ColorfulQrCodeIcon,
    ColorfulPasswordIcon,
    ColorfulCalculatorIcon,
    ColorfulWatermarkIcon,
    ColorfulPdfSecurityIcon,
    ColorfulHtmlIcon,
    ColorfulPptIcon,
    ColorfulPdfSplitIcon,
    ColorfulImageCompressorIcon,
    ColorfulBarcodeIcon,
    ColorfulImageUpscalerIcon,
    ColorfulVoiceToTextIcon
} from './Icons';

const ICONS = [
    ColorfulPdfImageIcon, ColorfulImageEditorIcon, ColorfulCurrencyIcon, ColorfulJsonIcon,
    ColorfulOcrIcon, ColorfulQrCodeIcon, ColorfulPasswordIcon, ColorfulCalculatorIcon,
    ColorfulWatermarkIcon, ColorfulPdfSecurityIcon, ColorfulHtmlIcon, ColorfulPptIcon,
    ColorfulPdfSplitIcon, ColorfulImageCompressorIcon, ColorfulBarcodeIcon,
    ColorfulImageUpscalerIcon, ColorfulVoiceToTextIcon
];

export const FloatingIconsBackground: React.FC = () => {
    const icons = React.useMemo(() => {
        // Render 10 icons for lightweight composite performance on mobile
        return Array.from({ length: 10 }).map((_, i) => {
            const IconComponent = ICONS[i % ICONS.length];
            const style = {
                left: `${(i * 10 + Math.random() * 5)}%`,
                top: `${(i * 10 + Math.random() * 5)}%`,
                animationDuration: `${12 + (i % 5) * 3}s`,
                animationDelay: `${(i % 4)}s`,
                transform: `scale(${0.6 + (i % 3) * 0.2})`,
            };
            return { Component: IconComponent, style, id: i };
        });
    }, []);

    return (
        <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none opacity-40 dark:opacity-20" aria-hidden="true">
            {icons.map(({ Component, style, id }) => (
                <div key={id} className="absolute animate-float will-change-transform" style={style}>
                    <Component className="w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20" />
                </div>
            ))}
        </div>
    );
};
